import axios from "axios";
import { API } from "../config/BackendUrl";

const FNFTUrl = `${API}/fractionNft`;

export const createFractionalNFT = async (data) => {
  const config = {
    method: "post",
    url: `${FNFTUrl}/create`,
    headers: {
      "Content-Type": "application/json",
    },
    data,
  };
  try {
    const res = await axios(config);
    console.log("res", res);

    return res.data;
  } catch (error) {
    console.log("error", error);
    return error.response.data;
  }
};

export const addFractionalNFT = async (data) => {
  const config = {
    method: "post",
    url: `${FNFTUrl}/add`,
    headers: {
      "Content-Type": "application/json",
    },
    data,
  };
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};

export const listActiveFractionalNFTs = async (params) => {
  const config = {
    method: "get",
    url: `${FNFTUrl}/`,
    params:params,
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};

export const listActiveFractionalNFTsForRedeems = async () => {
  const config = {
    method: "get",
    url: `${FNFTUrl}/redeem`,
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};

export const redeemFractionalNFTFunds = async (data) => {
  const config = {
    method: "post",
    url: `${FNFTUrl}/redeem`,
    headers: {
      "Content-Type": "application/json",
    },
    data,
  };
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};

export const contributeToFractionalNFT = async (data) => {
  const config = {
    method: "post",
    url: `${FNFTUrl}/contribute`,
    headers: {
      "Content-Type": "application/json",
    },
    data,
  };
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};

export const startFractionalNFTAuction = async (data) => {
  const config = {
    method: "post",
    url: `${FNFTUrl}/start-auction`,
    headers: {
      "Content-Type": "application/json",
    },
    data,
  };
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};

export const endFractionalNFTAuction = async (data) => {
  const config = {
    method: "post",
    url: `${FNFTUrl}/end-auction`,
    headers: {
      "Content-Type": "application/json",
    },
    data,
  };
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};

export const listFractionalNFTsByOwner = async (ownerAddress) => {
  const config = {
    method: "get",
    url: `${FNFTUrl}/owner/${ownerAddress}`,
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};

export const getFractionalNFTFromContract = async (fractionNFTId) => {
  const config = {
    method: "get",
    url: `${FNFTUrl}/fromContract/${fractionNFTId}`,
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};

export const getFractionalNFTFromLocal = async (fractionNFTId) => {
  const config = {
    method: "get",
    url: `${FNFTUrl}/fromLocal/${fractionNFTId}`,
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const res = await axios(config);
    console.log("res", res, res.data);

    return res.data;
  } catch (error) {
    return error.response.data;
  }
};
export const listFractionalNFTsInAuctions = async (id) => {
  const config = {
    method: "get",
    url: `${FNFTUrl}/in-auctions`,
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};
